import bugsnagVue from '@bugsnag/plugin-vue';
import bugsnag from '@bugsnag/js';
import Vue from 'vue';

const bugsnagClient = bugsnag('11f216642ec2529703b62a3c89493f58');

bugsnagClient.use(bugsnagVue, Vue);
export default bugsnagClient;
